export const homePage = {
    numberSte: 'Number: <span class="color-green">{count}</span> NFT',
    title: 'STE NFT Sportswear Collection',
    titleContent: 'Conditions to join INO:',
    lineContent1: 'Identity verified',
    lineContent2:
        'Each account can buy a maximum of 1 sportswear for men and 1 sportswear for women',
    buttonBuy: 'Buy',
    soldOut: 'Sold out',
    numberProducts: 'QTY: <span class="color-red">{count}</span> NFT',
    noLoginTitle: 'You have not logged in',
    contentNoLogin: 'You need to login to buy NFT.',
    buttonNoLogin: 'Log in',
    buttonVerify: 'Identity verification',
    changePass: 'Change password',
    logOut: 'Log out',
    ok: 'Confirm',
    noVerifyTitle: 'You have not verified your identity',
    chooseWallet: 'Choose wallet',
    notEnoughMoney: 'You don\'t have enough STE',
    confirmBuy: 'Confirm buy NFT',
    price: 'Price',
    confirmBuyButton: 'Confirm',
    loginBuy: 'Login to buy',
    timeup: 'The sales event has ended',
    remain: 'Remain: {remain}',
    titleConnectWallet: 'Connect Metamask',
    youNeedConnectMetamask: 'You need connect Metamask before buy nft.',
    connectWallet: 'Connect wallet',
    noVerifyContent: 'You need to re-verify to be able to buy NFTs',
    noVerifyButton: 'Verify',
    rejectVerifyTitle: 'Your account has been denied verification',
    rejectVerifyContent: 'You need to re-verify to be able to buy NFTs',
    rejectVerifyButton: 're-verify',
    pendingVerifyTitle: 'Your account is waiting for verification',
    penddingVerifyButton: 'Ok',

    approvedTitle: 'Open to selling soon',

    approvedSubTitle1: 'Start open on:',
    approvedLine1:
        "Phase 1: 30 NFT men's sportswear open for sale on June 15, 2022 12:00 UTC",
    approvedLine2:
        'Phase 2: 70 NFT women\'s sportswear open for sale on June 18, 2022 08:00 UTC',
    approvedSubTitle2: 'purchase conditions',
    approvedLine3:
        'Phase 3: 70 NFT men\'s sportswear and 30 NFT women\'s sportswear open for sale on June 21, 2022 08:00 UTC',
    approvedLine4: 'The total NFT men\'s sportswear is 100 and women\'s sportswear is 100',
    approvedLine5:
        'Each account can buy up to 1 men\'s sportswear and 1 women\'s sportswear',
    approvedLine6: 'Registered account and verified identity',

    approvedButton: 'Ok',

    connectPayButton: 'Connect wallet',
    successVerifyButton: 'Ok',
    pedding: 'Wait for verifying',
    message: {
        titleConnectWallet: 'Connect wallet.',
        deviceNotSupport: 'Unsupported device.',
        connectFail: 'Connection failed.',
        opened: 'Please open metamask to confirm login.',
    },
    buttonRegister: 'Register now',
    buttonTextVerify: 'Verify now',
    newItemTitle: 'Latest news',
    walletTitle: 'Wallet',
    walletBalance: 'Balance',
    peddingTitle: 'Your account are awesome precision',
    loadWallet: 'Deposit',
    loadWalletTitle: 'Deposit',
    loadWalletContent: 'BNB Smart Chain (BEP20)',
    loadWalletSubContent: 'Send STE, SB, BNB, USDT to this address.',
    walletAddress: 'Wallet address',
    scanAddress: 'Scan address to receive payment',
    withdrawWallet: 'Withdraw',
    withdrawWalletTitle: 'Withdraw STE',
    commonSoon: 'Coming soon',
    okie: 'Ok',
    copyAddress: 'Copy wallet address successfully',
    productTitle: "AIS's  NFTs collection",
    remainTimeBuy: 'Remaining selling time',
    bannerTitle: 'Discover the Best Premium, Unique and Exclusive NFT Collection',
    line1: 'June 21, 2022 08:00 UTC',
    line2: 'Phase 2: 70 NFT women\'s sportswear open for sale on June 18, 2022 08:00 UTC',
    bannerSubTitle: 'INO purchase conditions',
    line3: 'Phase 3: 70 NFT men\'s sportswear and 30 NFT women\'s sportswear open for sale on June 21, 2022 08:00 UTC',
    line4: 'The total NFT men\'s sportswear is 100 and women\'s sportswear is 100',
    line5: 'Each account can buy up to 1 men\'s sportswear and 1 women\'s sportswear',
    line6: 'Registered account and verified identity',
    haveOwned: 'Purchased',
    modalFire: {
        title: 'Congratulations!',
        subTitle: 'INO STE Phase <span>{count}</span> has ended',
        content1:
            'Thank you for your participation Congratulations to the members who have successfully owned NFT STE',
        content2:
            'If you haven\'t been lucky this time, please join phase <span>{count}</span> at 08:00 UTC on',
        stage1: ' June 18th',
        stage2: ' June 21th',
    },
    coming_soon: 'COMING SOON',

    filter_order: 'Arrange',
    filter_nft: 'Filter by NFT type',
    filter_mint: 'Filter by minting times',
    filter_token: 'Filter by tokens',
    newest: 'Newest',
    price_asc: 'Price: Low to high ↑',
    price_desc: 'Price: High to low ↓',
    all: 'All',
    nft_m: 'NFT M',
    nft_w: 'NFT W',
    nft_s: 'NFT S',
    nft_us: 'NFT US',
    nft_os: 'NFT OS',
    mint_couple: 'Mint couple',
    last1: 'One time left',
    last2: 'Two times left',
    last3: 'Three times left',
    last4: 'Four times left',
    last5: 'Five times left',
    last6: 'Six times left',
    last7: 'Seven times left',
    new: 'New',
    expire: 'Expired',
    cancel_sell: 'STOP SALE',
    confirm_cancel: 'Stop sale NFT',
    price_sell: 'Sale price:',
    fee: 'Selling fee 5%:',
    ste_receive: 'Number of {0} to receive:',
    couple_des: 'The NFTs that minted together must trade by pairs (NFT M and NFT W).',
    invite: 'Refer friends',
    invite_title: 'Invite friends',
    rule: 'Regulations',
    rule1: 'Share your referral/affiliate ID with a friend who doesn\'t have an account',
    rule2: 'Referral must successfully authenticate and participate in exercising',
    rule3: 'For every successful referral, you get four more days of free joining',
    id_invite: 'Your Referral ID',
    linkref: 'Link invite',
    ref_code: 'Referral Code',
    copy_success: 'Copy successful!',
    download: 'DOWNLOAD APP',
    condition_sell: 'NFT selling conditions',
    condition_sell1: '1. NFT is NEW (Not used yet).',
    condition_sell2: '2. Used NFTs need to be rewarded 7 times or more (NFTs receiving less than 7 times can not be sold)',
    condition_sell3: '3. The NFTs that minted together must be traded in pair (NFT M and NFT W).',
    condition_sell4: '4. NFT that has been used and received rewards 7 times or more when posting for sale will continue to count until the expiration date, when someone buys, the expiry date will automatically become EXPIRED, If the seller cancels the sale, the expiry date will be equal to the number of days being calculated.\n',
    condition_sell5: '5. NFTs that are listed for sale are not allowed to be used for exercising.\n',
    condition_sell6: '6. Used NFT must have minting turns.',
    nft_not_mint: 'The NFTs that have not been minted',
    sell: 'Sell',
    confirm_sell: 'Confirm selling NFT',
    transfer_confirm: 'Confirm transfer NFT',
    fee_transfer: 'Transfer fee:',
    sell_placeholder: 'Enter selling price',
    valid_price: 'Please enter selling price',
    priceSellRequired: 'Please enter selling price',
    confirm_text: 'Confirm',
    change_price: 'Change price',
    change_price_title: 'Change the NFT selling price',
    sell_success: 'Successful NFT sale!',
    nft_minted: 'The minted NFTs',
    history_title: 'History',
    history_text: 'Transaction history',
    nft_transaction: 'NFT transaction',
    ste_transaction: 'STE transaction',
    stt: 'STT',
    time: 'Time',
    type_transaction: 'Transaction type',
    type_nft: 'NFT type',
    id_nft: 'NFT ID',
    price_nft: 'Price',
    transfer_nft: 'Sender / Receiver',
    fee_nft: 'Fee',
    type_wallet: 'Wallet type',
    total: 'Total',
    hash: 'Hash',
    wallet_to: 'Receiving wallet address',
    status: 'Status',
    copySuccess: 'Copy Success',
    copyFail: 'Copy failed',
    not_available: 'NFT has been sold or not available!',
    transfer: "Transfer",
    collaborators_title: "Collaborators"
};
